import App from './App';
import axiosInstance, {setupAxiosClient} from './axiosWrapper/axiosWrapper';
import {appStore} from './redux/createStore';
import reportWebVitals from './reportWebVitals';
import unleash from './unleash-config';

import {ThemeProvider, ToastProvider} from '@deere/fuel-react';
import {FlagProvider} from '@unleash/proxy-client-react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import './index.css';

setupAxiosClient(appStore, axiosInstance);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ThemeProvider>
      <ToastProvider
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transitionDuration={1000}
      >
        <Provider store={appStore}>
          <FlagProvider config={unleash}>
            <App />
          </FlagProvider>
        </Provider>
      </ToastProvider>
    </ThemeProvider>
  </BrowserRouter>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js'
      );

      await navigator.serviceWorker.ready;

      const firebaseConfig = {
        apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
        authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
        projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
        storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
        appId: import.meta.env.VITE_FIREBASE_APP_ID,
        measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
      };

      navigator.serviceWorker.controller?.postMessage({
        type: 'FIREBASE_CONFIG',
        config: firebaseConfig,
      });
    } catch (err) {
      console.error('Service worker registration failed, error:', err);
    }
  });
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
